export class HTMLIdentifier {
  public identifyHTML(html: string) {
    const re = new RegExp(/<[a-z][\s\S]*>/);
    return re.test(html);
  }
}
